import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import CompanyPage from '@/components/CompanyPage'
import SolutionsPage from '@/components/SolutionsPage'
import ConsultingPage from '@/components/ConsultingPage'
import ServicePage from '@/components/ServicePage'
import ContactPage from '@/components/ContactPage'
import SiginIn from '@/components/user/Signin'
import SignUp from '@/components/user/Signup'
import ProfilePage from '@/components/user/ProfilePage'
import LegalPage from '@/components/LegalPage'
import PrivacyPage from '@/components/PrivacyPage'

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/company',
      name: 'Company',
      component: CompanyPage
    },
    {
      path: '/solutions',
      name: 'Solutions',
      component: SolutionsPage
    },
    {
      path: '/consulting',
      name: 'Consulting',
      component: ConsultingPage
    },
    {
      path: '/service',
      name: 'Service',
      component: ServicePage
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactPage
    },
    {
      path: '/signin',
      name: 'Signin',
      component: SiginIn
    },
    {
      path: '/signup',
      name: 'Signup',
      component: SignUp
    },
    {
      path: '/profile',
      name: 'Profile',
      component: ProfilePage
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: PrivacyPage
    },
    {
      path: '/legal',
      name: 'Legal',
      component: LegalPage
    }
  ],
  mode: 'history'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js